<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row" v-if="userData.permissions['patient_visits']==1">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm" :options="Options"></b-form-select> entries
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_filter" class="dataTables_filter text-md-end" >
                    <label class="d-inline-flex align-items-center">
                      Search: <b-form-input v-model="filter" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>
                    </label>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <b-table
                  :items="Items"
                  :fields="Fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="Filtered"
                  :busy="IsBusy"
                >
                <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>No Data Found</strong></div></template>
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(age)="data">
                  {{ data.item.age }} yrs
                </template>
                <template #cell(telephone)="data">
                  0{{ data.item.telephone }}
                </template>
                <template #cell(services)="data">
                  <b-button @click="edit(data.item.patient_id,data.item.name,data.item.gender,data.item.telephone )" type="button" class="btn-sm btn" variant="info" v-b-modal.edit> <i class="mdi mdi-eye"></i> view</b-button>
                </template>
                <template #cell(actions)="data">
                  <div class="btn-group">
                  <router-link :to="{ path: '/profile',  query: { id: data.item.patient_id }}" type="button" class="btn-sm btn btn-primary"> <i class="mdi mdi-square-edit-outline"></i> Profile</router-link>
                  </div>
                </template>
                </b-table>
              </div>
              <div class="row">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-end">
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
            <center><span class="text-primary h6">You have no permission to View Patients Visits</span></center>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="view-visit" centered title="View Patient Visit" title-class="font-14" hide-footer>
      <h6 class="text-dark"> Name : <span class="text-primary">{{ name }}</span>
       Gender : <span class="text-primary">{{ gender }}</span>
       Telephone : <span class="text-primary">0{{ telephone }}</span></h6>
      <table class="table table-sm mt-2" style="color: black;" density="compact">
      <thead><tr><th>Service Category</th><th>Service Name</th><th>Price</th></tr></thead>
        <tbody>
        <tr v-for="item in services" :key="item.id">
            <td>{{ item.service_category.name }}</td>
            <td>{{ item.service_name.name }}</td>
            <td>{{ item.service_price }}</td>
            </tr>
        </tbody>
      </table>
      <div class="form-group d-flex justify-content-end">
          <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('view-visit')" >Close</b-button>
      </div>
    </b-modal>

    <b-modal id="delete-visit" centered title="Discharge Patient" title-class="font-18" hide-footer>
        <form @submit.prevent="removeVisit">
            <input v-model="id" type="hidden">
              Are you sure you want to Discharge the Patient : <b>{{ name }}</b> ?
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('delete-visit')" >Close</b-button>
                <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> YES</b-button>
            </div>
        </form>
    </b-modal>

  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { visitMethods, visitComputed } from "@/state/helpers";

export default {
  page: {
    title: "Active Patient Visits",
    meta: [{ name: "description", content: appConfig.description,},],
  },
  components: {
    Layout,PageHeader
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "Active Patient Visits",
      items: [ {text: "Dashboard",to: "/",}, {text: "Active Patient Visits",active: true, }, ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
          { key: 'index', label: '#', visible: true },
          { key: 'id', label: 'ID', visible: false },
          { key: 'name', label: 'Name', visible: true },
          { key: 'gender', label: 'Gender', visible: true },
          { key: 'age', label: 'Age', visible: true },
          { key: 'telephone', label: 'Telephone', visible: true },
          { key: 'address', label: 'Address', visible: true },
          { key: 'services', label: 'Services', visible: true },
          { key: 'actions', label: 'Actions', visible: true },
        ],
      services:[],
      id:'',
      telephone:'',
      name:'',
      nationality:'',
      gender:'',
      address:'',
      dateofbirth:'',
    };
  },
  computed: {
    ...visitComputed,
    List() { return this.visits.length; },
    Fields() { return this.fields.filter(field => field.visible) },
    Items() { return this.visits.map((d) => ({...d }))},
    IsBusy() { let a=false; if (this.visits.length>0) { a=false;} else { a=true;} return a },
  },
  mounted() {
    this.fetchVisits();
    this.TotalRows = this.visits.length;
    this.isBusy=false;
  },
  methods: {
    ...visitMethods,
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    async edit(id,name,gender,telephone){
      this.id=id;
      this.name=name;
      this.gender=gender;
      this.telephone=telephone;
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/patientvisit";
      await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        this.services=response.data.visits;
        this.$bvModal.show('view-visit')
      }
    })
    },
    remove(id,name){
      this.id=id;
      this.name=name;
      this.$bvModal.show('delete-visit')
    },
  },
};
</script>